import { render } from "./VenueSlideshow.vue?vue&type=template&id=97e7fb9c&scoped=true"
import script from "./VenueSlideshow.vue?vue&type=script&lang=js"
export * from "./VenueSlideshow.vue?vue&type=script&lang=js"

import "./VenueSlideshow.vue?vue&type=style&index=0&id=97e7fb9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e7fb9c"]])

export default __exports__